module.exports = __webpack_public_path__ + "img/come-vict-07.c184fb57.jpg";